;(function(){
  'use strict';

  // 描画される前のDOMに対して対応
  function changeErrorImageBeforeRendering() {
    $('.js-external-link-nav-item-image').on('error', function() {
      $(this).after('<i class="far fa-external-link external-link-nav__item-icon"></i>');
      $(this).remove();
    });
  }

  // 描画された後のDOMに対して対応
  function changeErrorImageAfterRendering() {
    let externalLinkImage = $('.js-external-link-nav-item-image');

    $.each(externalLinkImage, function(index, value) {
      if (value.complete && value.naturalHeight == 0) {
        $(value).after('<i class="far fa-external-link external-link-nav__item-icon"></i>');
        $(value).remove();
      }
    })
  }

  $(function () {
    changeErrorImageBeforeRendering();
    changeErrorImageAfterRendering();
  });
}.call(this));